import React, { useState } from "react";
import { Stack, Box, Typography } from "@mui/material";
import useResponsive from "../../hooks/useResponsive";
import Header from "../../layout/dashboard/header";
import { useQuery } from "@tanstack/react-query";

import { apiGetUser } from "../../api/users";
import { useNotificationService } from "../../components/notification";
import {
  FacilityDataPropsType,
  FacilityDataPropsTypeDummy,
} from "../../interface/users";
import ProfileEditContent from "../../components/profile/ProfileEditContent";
import BackButton from "../../components/UIElements/BackButton";

const EditProfile = () => {
  const isMedium = useResponsive("down", "md", "xl");
  const { showNotification } = useNotificationService();
  const [facility_info, setFacility_info] = useState<FacilityDataPropsType>(
    FacilityDataPropsTypeDummy,
  );

  const { data, refetch, isLoading } = useQuery({
    queryKey: ["profileDetails"],
    queryFn: async () => {
      const result = await apiGetUser();

      if (result.status === "error" && "details" in result) {
        showNotification(data?.msg ?? "", "error");
        return FacilityDataPropsTypeDummy;
      }
      if (result?.status === 200) {
        setFacility_info(result.data?.data);
      }
      return result?.data?.data || FacilityDataPropsTypeDummy;
    },
  });

  return (
    <>
      {/* Header Menu */}
      <Header>
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "row",
            gap: "10px",
            justifyContent: "space-between",
            alignItems: "center",
            marginRight: "1rem",
            height: isMedium ? 60 : 75,
          }}
        >
          <Stack direction={"row"} alignItems={"center"} sx={{ gap: "10px" }}>
            <BackButton />
            <Typography
              variant={"subtitle1"}
              sx={{
                fontWeight: 500,
                fontFamily: "Lexend",
                color: "#2F66F4",
              }}
            >
              Edit Profile
            </Typography>
          </Stack>
        </Box>
      </Header>

      {!!data && !isLoading && <ProfileEditContent facility_info={data} />}
    </>
  );
};

export default EditProfile;
